module.exports = __webpack_public_path__ + "img/papers1.cfcd6e3c.png";